import { _x } from '@wordpress/i18n'
import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import { TranslatedHighlight } from '../../../../assets/utils/algolia/algoliaTranslation'
import type { HitComponentTemplateProps } from './HitComponent'
import useReplaceImgixUrl from '../../../../assets/utils/useReplaceImgixUrl'
import { useConfigContext } from './ConfigContext'

function CardHitComponent({
  hit,
  isNew,
  speakers,
  detailUrl,
  imageUrl,
  imageAlt,
  imageTitle,
  teaser
}: HitComponentTemplateProps) {
  const { imgixSrcUrl, imgixTargetUrl } = useConfigContext()
  const replaceImgixUrl = useReplaceImgixUrl(imgixSrcUrl, imgixTargetUrl)
  const imgixUrl = replaceImgixUrl(imageUrl, { width: 520 })

  return (
    <article
      data-bs-theme="dark"
      className="card h-100"
      style={{
        viewTransitionName: `card-${hit.objectID}`
      }}
    >
      <div className="card-tags card-tags--float">
        {isNew && (
          <div className="badge text-bg-primary">
            {_x('NEW', 'New Tag', 'icf')}
          </div>
        )}
      </div>
      {imageUrl ? (
        <div className="card-img-top">
          <img
            src={imgixUrl}
            alt={imageAlt}
            title={imageTitle}
            className="card-img-top"
            draggable={false}
            loading="lazy"
          />
        </div>
      ) : (
        <div className="card-img-top-placeholder" />
      )}
      <div className="card-body">
        <div className="d-flex flex-wrap gap-1">
          {speakers.map((s) => (
            <div key={s} className="card-meta-tag">
              {s}
            </div>
          ))}
        </div>
        <h3 className="card-title truncate-lines-2 mt-3">
          <TranslatedHighlight hit={hit} attribute="topic" />
        </h3>
        {!!teaser && (
          <p className="card-text truncate-lines-2">
            {teaser}
          </p>
        )}
        {!!detailUrl && (
          <div className="card-buttons">
            <a
              href={detailUrl}
              className="btn btn-sm btn-dark-1 card-stretched-link"
              aria-label={`${_x('Watch sermon', 'Sermons List Card Detail Link Screenreader Text', 'icf')} ${t(hit.topic, { fallback: 'none' })}`}
            >
              <span>
                {_x('Watch now', 'Sermons List Card Detail Link Button', 'icf')}
              </span>
              <i className="icon fs-base-const fa-arrow-right" />
            </a>
          </div>
        )}
      </div>
    </article>
  )
}

export default CardHitComponent
